import axios from 'axios'

export default {
    namespaced: true,
    state: {
        token: localStorage.getItem('access_token') || undefined,
        permission: [],
        lang: 'es',
    },
    getters: {
        loggedIn(state) {
            return state.token !== null;
        },
        getLang(state){
            return state.lang;
        }
    },
    mutations: {
        setLang(state, lang){
            state.lang = lang;
        },
        retrieveToken(state, data) {
            let userTID = (data.user.role === 'Estructurador') ? '' : data.user.TID;

            localStorage.setItem('access_token', data.token);
            localStorage.setItem('TID', userTID);

            axios.defaults.headers.post['TID'] = userTID;
            axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;

            state.permission = [];
            state.token = localStorage.getItem('access_token');
            data.menu_profile.forEach(element => {
                var elementIndex = (element.funcion) ? `${element.menu}-${element.funcion}` : element.menu;
                state.permission.push(elementIndex);
            });
            localStorage.setItem('permission', JSON.stringify(state.permission));
        },
        destroyToken(state) {
            localStorage.clear();
        },
        updateGlobalFilters(state, data) {
            localStorage.setItem('global_filters', JSON.stringify(data));
        },
        selectDefaultProcessRole(state, processRoles){
            let defaultFilter = [];
            let availableFilters = [];
            
            processRoles.forEach(element => availableFilters[element] = true);
            
            //Con este orden se permite dar prioridad a la dorma de mostrar los roles de proceso dentro del tablero
            switch (true) {
                case availableFilters['ENCARGADO']:
                    defaultFilter=['ENCARGADO'];
                    break;
                case availableFilters['RESPONSABLE']:
                    defaultFilter=['RESPONSABLE'];
                    break;
                case availableFilters['CONSULTA']:
                    defaultFilter=['CONSULTA'];
                    break;
                case availableFilters['TODOS']:
                    defaultFilter=['TODOS'];
                    break;
            
                default:
                    break;
            }
            localStorage.setItem('available_filters', JSON.stringify(processRoles));
            localStorage.setItem('global_filters', JSON.stringify(defaultFilter));
        }
    },
    actions: {
        changeLang(context, payload){
            context.commit('setLang', payload.lang);
        },
        retrieveTokenSSO(context, params) {
            return new Promise((resolve, reject) => {
                axios.post('/auth/login/sso', params
                ).then(response => {
                    if (response.data.status === 'success') {
                        context.commit('retrieveToken', response.data);
                        
                        if(response.data.user.role === 'Estructurador'){
                            context.commit('updateGlobalFilters', ["TODOS"]);
                            localStorage.setItem('available_filters', JSON.stringify(["TODOS"]));
                        }else{
                            context.commit('selectDefaultProcessRole', response.data.process_roles);
                        }
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        retrieveToken(context, credentials) {
            return new Promise((resolve, reject) => {
                axios.post('/auth/login', {
                    TID: credentials.TID,
                    email: credentials.email,
                    password: credentials.password,
                }).then(response => {
                    if (response.data.status === 'success') {
                        context.commit('retrieveToken', response.data);
                        
                        if(response.data.user.role === 'Estructurador'){
                            context.commit('updateGlobalFilters', ["TODOS"]);
                            localStorage.setItem('available_filters', JSON.stringify(["TODOS"]));
                        }else{
                            context.commit('selectDefaultProcessRole', response.data.process_roles);
                        }                        
                        sessionStorage.setItem('user_id', response.data.user.id);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        switchTenant(context, credentials) {
            return new Promise((resolve, reject) => {
                axios.post('/auth/users/switchTenant', {
                    TID: credentials.TID,
                    email: credentials.email
                }).then(response => {
                    
                    if (response.data.status === 'success') {
                        if(response.data.user.role === 'Estructurador'){
                            context.commit('updateGlobalFilters', ["TODOS"]);
                            localStorage.setItem('available_filters', JSON.stringify(["TODOS"]));
                        }else{
                            context.commit('selectDefaultProcessRole', response.data.process_roles);
                        }                          
                        context.commit('retrieveToken', response.data);
                        sessionStorage.setItem('avatar', JSON.stringify(response.data.user));
                        sessionStorage.setItem('user_id', response.data.user.id);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        destroyToken(context) {
            context.commit('destroyToken');
            return new Promise((resolve, reject) => {
                axios.post('/auth/logout').then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        updateGlobalFilters(context, data) {
            return context.commit('updateGlobalFilters', data.filter);
        },
    }

}
